module.exports = __webpack_public_path__ + "img/automatic.b16a6fb1.png";